var isNumber = require('../type/is-number');

var isPositive = function isPositive(num) {
  return isNumber(num) && num > 0;
};

module.exports = isPositive;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/is-positive.js
// module id = 300
// module chunks = 0 1 2